<template>
  <div class="overview">
    <Header title="最新公告" :more="true" />
  </div>
</template>

<script>
import Header from '../Header'

export default {
  components: { Header },
  name: 'Notice',

  data () {
    return {}
  },

  created () {}
}
</script>

<style lang="scss" scoped>
.overview {
  width: 100%;
  border-radius: 10px;
  height: 1.3rem;
  min-height: 110px;
  &__col {
    margin-top: 15px;
  }
  &__col:not(:last-child) {
    border-right: 1px solid rgb(242, 242, 242);
  }
  &__title {
    color: rgb(137, 149, 160);
    margin-bottom: 10px;
  }
}
</style>
